export default __webpack_public_path__ + "static/media/default_logo.1d81e602.jpg";